import {
  WP_REST_API_Post,
  WP_REST_API_Search_Result,
  WP_REST_API_Term,
  WP_User,
} from 'wp-types';
import { GF_Form } from './gforms/gform';
import { Step, WP_WizardStep } from './wizard/wizard';

interface AcfGForm {
  gform_activation: boolean;
  gform?: GF_Form;
}

export interface NewsView {
  postId: number;
  houseId: number;
  serviceId?: number;
  title: string;
  authorImgUrl: string;
  authorName: string;
  news_date: string;
  thumbnail_img: any;
  short_description: string;
  description: string;
  slug: string;
  alert: boolean;
  sticky: boolean;
  faq?: WP_Faq;
  form?: WP_Form;
  gform?: AcfGForm;
}

export interface WP_News extends IHousePage {
  fimg_url: boolean | string;
  slug: string;
  sticky: boolean;
  acf: {
    house: boolean | WP_HouseRef[];
    service?: false | WP_ServiceRef;
    alert: boolean;
    faq?: WP_Faq;
    form?: WP_Form;
    gform?: AcfGForm;
  };
}

export type WP_NewsArray = WP_News[];

export interface WP_Image {
  id: number;
  name: string;
  title: string;
  caption: string;
  description: string;
  author: number;
  date: string;
  modified: string;
  filename: string;
  filesize: number;
  height: number;
  width: number;
  icon: string;
  link: string;
  url: string;
  mime_type: string;
  type: string;
  subtype: string;
  sizes: {
    thumbnail: string;
    medium: string;
    medium_large: string;
    large: string;
    '1536x1536': string;
    '2048x2048': string;
  };
  uploaded_to: number;
}

export interface WP_TaxRef {
  term_id: number;
  term_group: number;
  term_taxonomy_id: number;
  slug: string;
  count: number;
  description: string;
  filter: string;
  name: string;
  parent: number;
  taxonomy: string;
}
export interface WP_HouseRef extends WP_TaxRef {}

export interface WP_HouseTerm extends WP_REST_API_Term {
  acf: {
    image: WP_Image;
    main: boolean | false;
    common_name: string | null;
    invoices: boolean;
    // address: string;
    // contact: string;
    // house: number;
    // links: any;
    // locations: boolean | string;
    // services: any;
  };
}

export type HouseArray = WP_HouseTerm[];

export interface WP_ServiceRef extends WP_TaxRef {}

export interface WP_ServiceTerm extends WP_REST_API_Term {
  acf: {
    image: WP_Image;
    label?: Array<Translation>;
  };
}

export interface EmergencyContact {
  title_fr: string;
  title_en: string;
  number: string;
  contact_type: string;
}

export interface User extends WP_User {
  username: string;
  id: number;
  first_name: string;
  last_name: string;
  name: string;
  avatar_urls: any;
  email: string;
  is_in_my_network?: boolean;
  qrcode?: {
    sport?: {
      url: string;
    };
    identification: {
      url: string;
    };
  };
  emergency_contacts?: Array<EmergencyContact>;
  acf: {
    user_house: false | WP_HouseRef[];
    locale: string;
    user_gia_type: string;
    user_honorary_title: string;
    staystart: string;
    stayend: string;
    photo?: string;
    mobilephone?: string | null;
    tags?: Array<WP_TagUser> | false;
    notifications?: boolean;
    confidentiality?: 'public' | 'private' | 'house';
    show?: Array<'image' | 'mobile' | 'name' | 'email' | 'house'>;
    wizard?: WP_WizardStep[] | false;
  };
  offline?: boolean;
  invoice_url?: string;
  invoice_download_url?: string;
}

export interface WP_DirUser {
  id: number;
  name: string;
  email: string;
  acf: {
    user_house: WP_HouseRef[];
    photo: string;
    mobilephone: string | null;
    notifications: boolean;
    tags: Array<WP_TagUser>;
  };
  in_my_network: boolean;
}

export type UserShowOption = 'image' | 'mobile' | 'name' | 'email' | 'house';
export interface UserUpdate {
  acf: {
    locale?: string;
    photo?: string;
    mobilephone?: string | null;
    tags?: boolean | Array<string>;
    notifications?: boolean;
    confidentiality?: 'public' | 'private' | 'house';
    show?: Array<UserShowOption>;
    wizard?: Array<{ slug: Step }>;
    user_house?: Array<number>;
  };
}

export interface UserParameters {
  locale: string;
  pushNotification: boolean;
  notifications: boolean;
  confidentiality: 'public' | 'private' | 'house';
  photo: string;
  establishment: number | undefined;
  discipline: number | undefined;
  studyYear: number | undefined;
  interest: number[];
  show: {
    image: boolean;
    mobile: boolean;
    email: boolean;
    name: boolean;
    house: boolean;
  };
}

export const DEFAULT_AVATAR_URL = '/assets/img/default-avatar.png';

export interface File {
  id: number;
  title: string;
  filename: string;
  filesize: number;
  url: string;
  link: string;
  alt: string;
  author: string;
  description: string;
  caption: string;
  name: string; // "team-leadoff"
  date: string; // "2021-07-27 14:59:03"
  modified: string; // "2021-07-27 14:59:03"
  menu_order: number; // 0
  mime_type: string; // "application/pdf"
  type: string; // "application"
  subtype: string; // "pdf"
  icon: string; // "http://localhost:8001/wp-includes/images/media/document.png"
  // sizes: {
  //   "1536x1536": string;
  //   "1536x1536-height": string;
  //   "1536x1536-width": string;
  //   "2048x2048": string;
  //   "2048x2048-height": string;
  //   "2048x2048-width": string;
  //   large: string;
  //   "large-height": string;
  //   "large-width": string;
  //   medium: string;
  //   "medium-height": string;
  //   "medium-width": string;
  //   medium_large: string;
  //   "medium_large-height": string;
  //   "medium_large-width": string;
  //   thumbnail: string;
  //   "thumbnail-height": string;
  //   "thumbnail-width": string;
  // };
}
interface IAppLink {
  acf_fc_layout: 'pdf' | 'external_link';
}
export interface UrlLink extends IAppLink {
  name: string;
  url: string;
  icon: Icon;
}

export interface PdfLink extends IAppLink {
  name: string;
  link: File;
  icon: Icon;
}

export type AppLink = PdfLink | UrlLink;
export interface Icon {
  element: string;
  class: string;
  hex: string;
  unicode: string;
  prefix: string;
}

export interface Location {
  name: string;
  url: string;
  place?: boolean | number;
}

export interface IHousePage extends WP_REST_API_Post {
  'tax-house': number[];
}
export interface WP_HouseMainPage extends IHousePage {
  acf: {
    house: number;
    address: string;
    links: UrlLink[];
    faq?: WP_Faq;
    contact: string;
    locations: boolean | Location[];
  };
}
export interface HouseService extends IHousePage {
  acf: {
    icon: Icon;
    links: boolean | AppLink[];
    faq: WP_Faq;
    form: WP_Form;
    gform?: AcfGForm;
  };
}

export type HouseInfo = WP_HouseMainPage | HouseService;

export type HousePageArray = HouseInfo[];

export interface WP_ServiceCategory {
  value: string;
  label: string;
}

export interface WP_Service extends WP_REST_API_Post {
  acf: {
    subtitle: string;
    color: string;
    icon: Icon;
    image: WP_Image;
    cover: WP_Image;
    links: boolean | AppLink[];
    faq: WP_Faq;
    form: WP_Form;
    gform?: AcfGForm;
    service_category?: WP_ServiceCategory[];
  };
  menu_order: number;
}

export type ServiceArray = WP_Service[];

export interface WP_Page extends WP_REST_API_Post {
  acf: {
    faq: WP_Faq;
    form: WP_Form;
    gform?: AcfGForm;
  };
}

export interface WP_Event extends IHousePage, WP_REST_API_Post {
  fimg_url: boolean | string;
  acf: {
    organizer: number;
    service?: false | WP_ServiceRef;
    visibility: {
      value: string;
      label: string;
    };
    start: string;
    end: string;
    practical: string;
    origin: string;
    external_id: string;
    external_mtime: string;
    external_url: string;
    locations: [];
    faq?: WP_Faq;
    form?: WP_Form;
    gform?: AcfGForm;
  };
}

export type WP_EventsArray = WP_Event[];

export interface WP_Notif extends WP_REST_API_Post {
  acf: {
    sended_date: Date;
    link: string;
    recipient: string;
    state: string;
    type: string;
    sender: number;
  };
}

export type WP_NotifsArray = WP_Notif[];

export interface NotifUpdate {
  acf: {
    state?: 'read' | 'unread';
  };
}

export type RelationStatus =
  | 'none'
  | 'requested'
  | 'accepted'
  | 'refused'
  | undefined;

export type RelationAction =
  | 'delete'
  | 'request'
  | 'accept'
  | 'refuse'
  | 'prompt'
  | 'none';

export interface WP_UserNetwork extends WP_REST_API_Post {
  acf: {
    user_a: number;
    user_b: number;
    relation_status: RelationStatus;
  };
}

export interface UserNetworkUpdate {
  status?: 'publish' | 'draft';
  acf: {
    user_a?: number;
    user_b?: number;
    relation_status?: RelationStatus;
  };
}
export interface WP_FaqItem {
  faq_ask: string;
  faq_answer: string;
}

export type WP_Faq = WP_FaqItem[];

export interface WP_Form {
  form_activation: boolean;
  form_title: string;
  form_email_receiver: string;
}

export interface WP_Entry extends WP_REST_API_Post {
  acf: {
    entry_id_post: number;
    entry_service_email: string;
    entry_datas: Array<EntryData>;
  };
}

export interface EntryUpdate {
  status: 'draft' | 'publish';
  title: string;
  acf: {
    entry_id_post: number;
    entry_service_email: string;
    entry_datas: Array<EntryData>;
    entry_status: string;
  };
}

export interface EntryData {
  entries_datas_key: string;
  entries_datas_value: string;
}

export interface Translation {
  lang: string;
  value: string;
}

export interface WP_TagUser extends WP_TaxRef {
  acf: {
    label: Array<Translation>;
  };
}

export type WP_SubType =
  | 'post'
  | 'event'
  | 'house'
  | 'service'
  | 'user'
  | 'places';
export type SearchCategory =
  | 'all'
  | 'news'
  | 'events'
  | 'house'
  | 'services'
  | 'users'
  | 'places';
export interface SearchParams {
  type: 'post' | 'user';
  subtype: WP_SubType;
}

export const SearchCategoryParams: { [K: string]: SearchParams } = {
  news: { type: 'post', subtype: 'post' },
  events: { type: 'post', subtype: 'event' },
  house: { type: 'post', subtype: 'house' },
  services: { type: 'post', subtype: 'service' },
  users: { type: 'user', subtype: 'user' },
  places: { type: 'post', subtype: 'places' },
};

export const ALL_SEARCH_CATEGORIES = [
  'news',
  'events',
  'services',
  'users',
  'places',
] as Array<SearchCategory>;

export interface SearchResult<T> {
  category: SearchCategory;
  item: T;
}

export type SearchPostType = WP_News | WP_Event | HouseService | WP_Service;

export type SearchResultType = SearchPostType | WP_DirUser;
export interface WP_Search_Result<T> extends WP_REST_API_Search_Result {
  _embedded: {
    self: Array<T>;
  };
}
export interface WP_Pagination {
  page?: number;
  per_page?: number;
  offset?: number;
}

export interface WP_PaginationResult<T> {
  items: Array<T>;
  total: number;
  totalPages: number;
}

export interface ShowOptions {
  image?: boolean;
  mobile?: boolean;
  name?: boolean;
  house?: boolean;
  email?: boolean;
}
